export default {
  admin: {
    zh: '管理员',
    en: 'Administrator',
  },
  users: {
    zh: '用户',
    en: 'Users',
  },
  username: {
    zh: '用户名',
    en: 'Username',
  },
  createUser: {
    zh: '创建用户',
    en: 'Create User',
  },
  editUser: {
    zh: '编辑用户',
    en: 'Edit User',
  },
  role: {
    zh: '角色',
    en: 'Role',
  },
  roles: {
    zh: '角色',
    en: 'Roles',
  },
  createRole: {
    zh: '创建角色',
    en: 'Create Role',
  },
  editRole: {
    zh: '编辑角色',
    en: 'Edit Role',
  },
  roleName: {
    zh: '角色名称',
    en: 'Role Name',
  },
  permissionList: {
    zh: '权限列表',
    en: 'Permission List',
  },
  create: {
    zh: '创建',
    en: 'Create',
  },
  get: {
    zh: '查看',
    en: 'Get',
  },
  update: {
    zh: '更新',
    en: 'Update',
  },
  delete: {
    zh: '删除',
    en: 'Delete',
  },
}
